import { AppBar, Toolbar, Box, Button, Stack, IconButton } from "@mui/material";
import styles from "./styles";
import { IoMenuOutline } from "react-icons/io5";
import theme from "../../theme/Theme";
import { Logo } from "../../assets";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../component/CustomButton";

const AdminHeader = ({ toggleSidebar, isMobile }) => {
    const navigate = useNavigate();

    const handleBackToDashboard = () => {
        navigate("/dashboard/tickets");
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                margin: 0,
                padding: 0,
                boxShadow: "none",
                backgroundColor: theme.custom.white,
            }}
        >
            <Toolbar
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: { xs: "0 1rem", md: "0 2rem" },
                }}
            >

                <Stack direction="row" alignItems="center" spacing={2}>
                    {isMobile && (
                        <IconButton onClick={toggleSidebar} sx={{ color: theme.palette.primary.main }}>
                            <IoMenuOutline color={theme.palette.primary.dark} />
                        </IconButton>
                    )}
                    <Box component="img" src={Logo} alt="Logo" sx={styles.logo} />

                </Stack>


                <CustomButton
                    title="Back to Dashboard"
                    onClick={handleBackToDashboard}
                />
            </Toolbar>
        </AppBar>
    );
};

export default AdminHeader;
